const elementHasClass = (value, className) => value.classList.contains(className)

const removeClass = (element, className) => element.classList.remove(className)

const addClass = (element, className) =>
    element.classList.add(className)

export const accessibly = (element, className) =>
    elementHasClass(element, className) ?
        removeClass(element, className) :
        addClass(element, className)

export const elementsByClass = (className) => Array.from(document.getElementsByClassName(className))

export const applyColourAccessibility = () => {
    elementsByClass("accessibility-img").map((element) =>
        accessibly(element, "access-image-black"))
    elementsByClass("accessibility-line").map((element) =>
        accessibly(element, "removable"))
    waveAccessibility();
}

export const applyFontSizeAccessibility = () => {
    elementsByClass("accessibility-font").map((element) =>
        accessibly(element, "accessible-font"))
}

const setAttributeOfElement = (attribute, element, value) => element.setAttribute(attribute, value)

const getSVGOfComponent = (waveHeader) => waveHeader.firstElementChild.firstElementChild

const styleIsApplied = (waveHeader) => getSVGOfComponent(waveHeader).getAttribute("fill") !== "black"

export const waveAccessibility = () => {
    const waveHeader = document.getElementsByClassName("w-header")?.item(0) || null;
    const wave = document.getElementsByClassName("w-body")?.item(0) || null;
    if(wave !== null && waveHeader !== null){
        if (styleIsApplied(waveHeader)) {
            setAttributeOfElement("fill", getSVGOfComponent(waveHeader), "black")
            setAttributeOfElement("style", wave, "background-color:black");
        } else {
            setAttributeOfElement("fill", getSVGOfComponent(waveHeader), "#EE303B")
            setAttributeOfElement("style", wave, "background-color:#EE303B")
        }
    }

}
